'use strict'

import browser from '@beastshop/browser'


const CLIP_MAP = {
  'product': {
    'width': 690,
    'height': 721
  },
  'simple-product': {
    'width': 330,
    'height': 345
  },
  'pack': {
    'width': 170,
    'height': 178
  },
  'addible-pack': {
    'width': 100,
    'height': 104
  },
  'package': {
    'width': 130,
    'height': 136
  }
}

const defaultImage = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII=`

const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

export function transform ({data, containerWidth, clipData, suffix, fixWidth}) {
  if(!data) {
    return {}
  }
  if (typeof data === 'string') {
    return {
      src: formatStuff({
        data: data,
        suffix: suffix,
        fixWidth: fixWidth
      }),
      width: "",
      height: ""
    }
  }

  let formatData = formatData = formatZoom(data.width, data.height, containerWidth)
  let url = formatStuff({
    data: data,
    formatData: formatData,
    clipData: clipData,
    suffix: suffix,
    fixWidth: fixWidth
  })
  formatData.src = url
  return formatData
}

export function formatZoom (width, height, containerWidth) {
  if(!width || !height) {
    return {}
  }

  const zoomWidth = containerWidth?containerWidth:clientWidth
  const zoomHeight = parseFloat(zoomWidth/width * height)

  return {
    width: zoomWidth,
    height: zoomHeight
  }
}

export function formatStuff ({data, formatData, clipData, suffix, fixWidth}) {
  if(!data) {
    return ""
  }

  let url = ''
  let width = ''
  let height = ''

  if(typeof data === 'string') {
    url = decodeURIComponent(data)
  } else {
    url = decodeURIComponent(data.url || data.src)
    width = data.width
    height = data.height
  }

  let stuffIndex = url.lastIndexOf('.')
  let stuffMidIndex = url.lastIndexOf('@')
  let stuffAdditionIndex = url.lastIndexOf('|')
  let urlLen = url.length

  if(!~stuffIndex) {
    return url
  }

  let oldStuff = ''
  if(suffix) {
    oldStuff = `.${suffix}`
  } else {
    if(~stuffAdditionIndex) {
      oldStuff = url.substring(stuffIndex, stuffAdditionIndex)
    } else {
      oldStuff = url.substring(stuffIndex)
    }
    oldStuff = oldStuff.toLowerCase()
  }
  if(oldStuff !== ".jpg" && oldStuff !== ".jpeg" && oldStuff !== ".png" && oldStuff !== ".webp") {
    return url
  }

  let stuff = '.webp'
  let newUrl = url
  if(browser.ios() || !/i(?:pod|phone|pad)|android|micromessenger/i.test(navigator.userAgent)) {//webview ios || pc
    stuff = (oldStuff==='.webp')?'.jpg':oldStuff
  }

  let clipSize = {}

  if(clipData) {//'product' {'type':'product','width':'','height':''}
    if(typeof clipData === 'string') {
      if(CLIP_MAP[clipData]) {
        clipSize = CLIP_MAP[clipData]
      }
    } else {
      if(clipData['type'] && CLIP_MAP[clipData['type']]) {
        clipSize = CLIP_MAP[clipData['type']]
      } else {
        clipSize['width'] = clipData['width']
        clipSize['height'] = clipData['height']
      }
    }

  }

  if(clipSize['width'] && clipSize['height'] && !~stuffMidIndex) {
    newUrl = url + `@4e_0o_0l_${clipSize['height']}h_${clipSize['width']}w_90q` +stuff
    return newUrl
  }

  if(!~stuffMidIndex || stuffMidIndex>stuffIndex) {// no @
    let formatObj = formatRangeSize(formatData)
    newUrl = url + formatRangeStuff({
      width: width,
      formatObj: formatObj,
      fixWidth: fixWidth
    }) + stuff
    return newUrl
  }

  //has @
  let stuffMidStr = url.substring(stuffMidIndex, stuffIndex)
  let stuffAdditionStr = ''
  if(~stuffAdditionIndex && stuffAdditionIndex>stuffMidIndex) {//has |
    stuffAdditionStr = url.substring(stuffAdditionIndex)
  }

  if(width && height) {
    // const whObj = this._formatStuffZoom(width, height)
    // stuffMidStr = `@4e_0o_0l_${whObj.height}h_${whObj.width}w_90q`
    let formatObj = formatRangeSize(formatData)
    stuffMidStr = formatRangeStuff({
      width: width,
      formatObj: formatObj,
      stuffMidStr: stuffMidStr,
      fixWidth: fixWidth
    })
  }
  newUrl = url.substring(0, stuffMidIndex) + stuffMidStr + stuff + stuffAdditionStr

  return newUrl
}

function formatRangeSize (formatData) {
  return {
    'width': 750
  }
}

function formatRangeStuff ({width, formatObj, stuffMidStr, fixWidth}) {
  let midStuff = ''
  if(fixWidth) {
    midStuff =  `@0o_0l_${fixWidth}w_90q`
  } else {
    if(width && width >= formatObj.width) {
      midStuff =  `@0o_0l_${formatObj.width}w_90q`
    } else {
      if(stuffMidStr) {
        midStuff = stuffMidStr
      } else {
        midStuff = '@90q'
      }
    }
  }
  return midStuff
}

// export DEFAULT_IMAGE = defaultImage



// WEBPACK FOOTER //
// ./static/components/image/lib/util.js